import {
  StorageDownloadUrlResponseSchema,
  StorageUploadUrlResponseSchema,
  type StorageDownloadUrlResponse,
  type StorageUploadUrlRequest,
  type StorageUploadUrlResponse,
} from '@magimp/shared';
import { request, requestBlob, type BinaryDownloadResult } from '../client.js';

export function requestUploadUrl(
  input: StorageUploadUrlRequest,
): Promise<StorageUploadUrlResponse> {
  return request<StorageUploadUrlResponse>(
    '/files/upload-url',
    {
      method: 'POST',
      body: JSON.stringify(input),
      headers: { 'content-type': 'application/json' },
    },
    {},
    StorageUploadUrlResponseSchema,
  );
}

export function requestItemPhotoDownloadUrl(
  requestId: string,
  itemId: string,
  objectKey: string,
): Promise<StorageDownloadUrlResponse> {
  return request<StorageDownloadUrlResponse>(
    `/requests/${encodeURIComponent(requestId)}/items/${encodeURIComponent(
      itemId,
    )}/photo-download-url`,
    {
      method: 'POST',
      body: JSON.stringify({ objectKey }),
      headers: { 'content-type': 'application/json' },
    },
    {},
    StorageDownloadUrlResponseSchema,
  );
}

// WHY (#599): nested box-item photo download URL. Mirror of the items
//   helper above; backend route lives at
//   `:id/boxes/:boxId/items/:boxItemId/photo-download-url`.
export function requestBoxItemPhotoDownloadUrl(
  requestId: string,
  boxId: string,
  boxItemId: string,
  objectKey: string,
): Promise<StorageDownloadUrlResponse> {
  return request<StorageDownloadUrlResponse>(
    `/requests/${encodeURIComponent(requestId)}/boxes/${encodeURIComponent(
      boxId,
    )}/items/${encodeURIComponent(boxItemId)}/photo-download-url`,
    {
      method: 'POST',
      body: JSON.stringify({ objectKey }),
      headers: { 'content-type': 'application/json' },
    },
    {},
    StorageDownloadUrlResponseSchema,
  );
}

/**
 * @aiPurpose download the per-request XLSX export as a Blob plus the
 *   Content-Disposition filename. The button caller owns the
 *   download-trigger side effect (object URL + anchor click + revoke);
 *   isolating it here keeps the API helper free of DOM coupling so the
 *   same wrapper can serve future non-DOM consumers.
 */
export function downloadRequestItemsXlsx(
  requestId: string,
  opts: { signal?: AbortSignal } = {},
): Promise<BinaryDownloadResult> {
  return requestBlob(`/requests/${encodeURIComponent(requestId)}/export.xlsx`, opts);
}
